var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._g(_vm._b({staticClass:"app-switch",class:{ 'primary-color': _vm.primaryColor },attrs:{"inset":"","dense":"","hide-details":""}},'v-switch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }